const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'fullice:first_touch';

function clean(value) {
  return value?.trim().slice(0, 200) || '';
}

function readLandingTouch() {
  const params = new URLSearchParams(window.location.search);
  const touch = Object.fromEntries(UTM_KEYS.map((key) => [key, clean(params.get(key))]).filter(([, value]) => value));
  if (!Object.keys(touch).length) return null;

  return {
    ...touch,
    landing_page: `${window.location.pathname}${window.location.search}`.slice(0, 500),
    captured_at: new Date().toISOString(),
  };
}

function getFirstTouch() {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    if (stored && typeof stored === 'object') return stored;
  } catch (_error) {
    // Storage can be unavailable under strict privacy settings; attribution must never block shopping.
  }
  return null;
}

function saveFirstTouch(touch) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(touch));
  } catch (_error) {
    // No-op: Shopify analytics and checkout remain untouched.
  }
}

async function attachToCart(touch) {
  if (!touch) return;
  const attributes = {};
  for (const key of UTM_KEYS) if (touch[key]) attributes[`_ft_${key}`] = touch[key];
  if (touch.landing_page) attributes._ft_landing_page = touch.landing_page;
  if (touch.captured_at) attributes._ft_captured_at = touch.captured_at;

  try {
    await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
      keepalive: true,
    });
  } catch (_error) {
    // Attribution is supplemental and must never interrupt add-to-cart or checkout.
  }
}

const landingTouch = readLandingTouch();
const storedTouch = getFirstTouch();
if (landingTouch && !storedTouch) {
  saveFirstTouch(landingTouch);
}

let attachedOnPage = false;
document.addEventListener('cart:update', (event) => {
  if (event.detail?.data?.didError || attachedOnPage) return;
  attachedOnPage = true;
  attachToCart(getFirstTouch());
});
